import React from 'react';
import Lottie from 'react-lottie';
import './Order_Successfull_Lottie.css';
import * as animationData from './Order_Successfull_Lottie.json';

function Order_Successfull_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Order_Successfull_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}
                // height={60}
                // width={60}          
                />       
        </div>
      </section>
    );
}
export default Order_Successfull_Lottie;